module.exports = __webpack_public_path__ + "img/S3.4ae7bc04.jpg";